import { SET_IS_LOGGED_IN,SET_PASSWORD, SET_BEARER_TOKEN, SET_USERNAME } from './userTypes';

export const setIsLoggedIn = (isLoggedIn) => ({
  type: SET_IS_LOGGED_IN,
  payload: { isLoggedIn }
});

export const setBearerToken = (bearerToken) => ({
  type: SET_BEARER_TOKEN,
  payload: { bearerToken }
});

export const setUsername = (username) => ({
  type: SET_USERNAME,
  payload: { username }
});

export const setPasswordofuser=(pass)=>({
  type: SET_PASSWORD,
  payload:{pass}
});
